export default __webpack_public_path__ + "static/media/left-chart-template.png?.4e9e655e";